var map = {
	"./aho.png": 7488,
	"./bergeron.png": 7912,
	"./bertuzzi.png": 4083,
	"./bouchard.png": 2110,
	"./draisaitl.png": 3267,
	"./eichel.png": 2104,
	"./fox.png": 2985,
	"./garland.png": 8335,
	"./guentzel.png": 9316,
	"./heiskanen.png": 8834,
	"./hintz.png": 5265,
	"./hischier.png": 9707,
	"./hoglander.png": 6122,
	"./hughes.png": 588,
	"./hyman.png": 4817,
	"./kane.png": 8467,
	"./kreider.png": 6500,
	"./kucherov.png": 479,
	"./lindholm.png": 2545,
	"./mackinnon.png": 4956,
	"./makar.png": 6002,
	"./marchand.png": 1272,
	"./marchessault.png": 570,
	"./marner.png": 5863,
	"./matthews.png": 4873,
	"./mcavoy.png": 933,
	"./mcdavid.png": 1352,
	"./miller.png": 5147,
	"./necas.png": 4484,
	"./nugent-hopkins.png": 1206,
	"./nylander.png": 9289,
	"./panarin.png": 4263,
	"./pastrnak.png": 5840,
	"./pavelski.png": 4377,
	"./pettersson.png": 4805,
	"./point.png": 8728,
	"./rantanen.png": 4625,
	"./reinhart.png": 485,
	"./robertson.png": 9018,
	"./scheifele.png": 6860,
	"./seguin.png": 7693,
	"./stamkos.png": 8710,
	"./stephenson.png": 8425,
	"./svechnikov.png": 9934,
	"./tavares.png": 5506,
	"./tkachuk.png": 8911,
	"./trocheck.png": 5919,
	"./zibanejad.png": 8226
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7958;